import React from "react";
import { CircularProgress, Box } from "@mui/material";

const LoadingSuspense = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress color="info" sx={{ marginRight: 2 }} /> Loading ...
    </Box>
  );
};

export default LoadingSuspense;
